import { render, staticRenderFns } from "./scientifictechnological.vue?vue&type=template&id=5c7f4488&scoped=true&"
import script from "./scientifictechnological.vue?vue&type=script&lang=js&"
export * from "./scientifictechnological.vue?vue&type=script&lang=js&"
import style0 from "./scientifictechnological.vue?vue&type=style&index=0&id=5c7f4488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7f4488",
  null
  
)

export default component.exports